/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_InvalidInputs */

const en_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use 3–20 letters, numbers, or underscores.`)
};

const de_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie 3–20 Buchstaben, Zahlen oder Unterstriche.`)
};

const pt_br2_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use de 3 a 20 letras, números ou sublinhados.`)
};

const tr_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3–20 harf, rakam veya alt çizgi kullanın.`)
};

const zh_cn2_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请使用 3–20 个字母、数字或下划线。`)
};

const zh_hk2_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請使用 3–20 個英文字母、數字或底線。`)
};

const ko_kr2_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문자, 숫자 또는 밑줄 3~20자를 사용하세요.`)
};

const ru_ru2_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте от 3 до 20 букв, цифр или знаков подчёркивания.`)
};

const es_419_onboarding_v1_username_invalid = /** @type {(inputs: Onboarding_V1_Username_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa entre 3 y 20 letras, números o guiones bajos.`)
};

/**
* | output |
* | --- |
* | "Use 3–20 letters, numbers, or underscores." |
*
* @param {Onboarding_V1_Username_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_invalid = /** @type {((inputs?: Onboarding_V1_Username_InvalidInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_InvalidInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_invalid(inputs)
	if (locale === "de") return de_onboarding_v1_username_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_invalid(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_invalid(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_invalid(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_invalid(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_invalid(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_invalid(inputs)
	return es_419_onboarding_v1_username_invalid(inputs)
});